<script lang="ts">
  import { auth } from '$lib/stores/auth';

  let password = '';
  let confirm = '';
  let done = false;
  let mismatch = '';

  async function submit() {
    mismatch = '';
    if (password !== confirm) {
      mismatch = 'Passwords do not match.';
      return;
    }
    const ok = await auth.updatePassword(password);
    if (ok) done = true;
  }
</script>

<div class="reset-container">
  <h2>Set a new password</h2>

  {#if done}
    <p class="info">Your password has been updated. You're now signed in.</p>
  {:else}
    {#if mismatch}
      <p class="error">{mismatch}</p>
    {:else if $auth.error}
      <p class="error">{$auth.error}</p>
    {/if}
    <div class="fields">
      <input type="password" bind:value={password} placeholder="New password" />
      <input type="password" bind:value={confirm} placeholder="Confirm new password" />
      <button on:click={submit} disabled={$auth.loading}>Update password</button>
    </div>
    <button class="link" on:click={() => auth.exitRecoveryMode()}>Cancel</button>
  {/if}
</div>

<style>
  .reset-container {
    max-width: 400px;
    margin: 2rem auto;
    padding: 2rem;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    text-align: center;
  }

  .fields {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  input {
    padding: 0.75rem 1rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
  }

  button {
    padding: 0.75rem 1rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: white;
    cursor: pointer;
    font-size: 1rem;
  }

  button:hover {
    background: #f5f5f5;
  }

  .error {
    color: #d32f2f;
    margin-bottom: 1rem;
  }

  .info {
    color: #666;
  }

  .link {
    background: none;
    border: none;
    color: #1565c0;
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
  }
</style>
